import React, { Component } from 'react';
import { connect } from 'react-redux';
import DocumentationView from './Documentation.view';

export class DocumentationContainer extends Component {

  constructor(props) {
    super(props);

    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.onCommentFormUpdate = this.onCommentFormUpdate.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.submitCommentForm = this.submitCommentForm.bind(this);
    this.deleteComment = this.deleteComment.bind(this);
  }

  componentDidMount() {
    const { dispatch, type } = this.props;
    dispatch({
      type: 'FETCH_DOCUMENTATION',
      payload: {
        type,
      },
    });
  }

  onFormUpdate(formState, actions) {
    const { dispatch } = this.props;
    dispatch({
      $global: true,
      type: 'ON_FORM_UPDATE',
      payload: {
        formState,
      },
    });
  }

  onCommentFormUpdate(commentFormState, actions) {
    const { dispatch } = this.props;
    dispatch({
      $global: true,
      type: 'ON_COMMENT_FORM_UPDATE',
      payload: {
        commentFormState,
      },
    });
  }

  submitForm(formState) {
    const { dispatch, documentation } = this.props;
    dispatch({
      $global: true,
      type: 'UPDATE_DOCUMENTATION',
      payload: {
        id: documentation._id,
        text: formState.data.text,
        type: documentation.type,
      },
      meta: {
        onComplete: ()=> {
          this.view.setState({
            editMode: false,
          })
        },
      }
    });

  }

  submitCommentForm(commentFormState) {
    const { dispatch, type, username, documentation } = this.props;
    dispatch({
      $global: true,
      type: 'ADD_COMMENT',
      payload: {
        username,
        type,
        user_id: commentFormState.data.user_id,
        key: documentation.type,
        comment: commentFormState.data.comment,
      },
    });

  }

  deleteComment(id) {
    const { dispatch, type } = this.props;
    if(confirm('Are you sure you want to delete this comment?')){
      dispatch({
        $global: true,
        type: 'DELETE_COMMENT',
        payload: {
          id,
          type,
        },
      });
    }
  }

  render() {
    return (<DocumentationView
      ref={ref=> this.view = ref}
      {...this.props}
      onFormUpdate={this.onFormUpdate}
      onCommentFormUpdate={this.onCommentFormUpdate}
      submitForm={this.submitForm}
      submitCommentForm={this.submitCommentForm}
      deleteComment={this.deleteComment}
    />);
  }

}

function mapStateToProps(state) {
  const { formState, commentFormState, documentation } = state.documentation;
  return {
    username: state.auth.username,
    formState,
    commentFormState,
    documentation,
  };
}

export default connect(mapStateToProps)(DocumentationContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/Documentation/Documentation.container.js